import { AdminApi } from '@guiker/real-estate-shared'
import { TypeOf, yup } from '@guiker/shared-framework'

export const updatePropertyUnits = yup.object({
  property: AdminApi.Schema.getUnitsSchema('$property.building.type'),
})

export type UpdatePropertyUnits = TypeOf<typeof updatePropertyUnits>
